import { css } from "@emotion/react";
import React from "react";
import { SwarovskiButton } from "../../components/_shared-components/ui-elements/SwarovskiButton";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { NewsletterHeadlineWithParagraph } from "./NewsletterHeadlineWithParagraph";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../../components/T";

export const NewsletterPopupThankYou: ReactTFC<{
  headline: TranslatedValue;
  paragraph: TranslatedValue;
  buttonLabel: TranslatedValue;
  buttonAction: () => void;
}> = props => {
  return (
    <>
      <NewsletterHeadlineWithParagraph headline={props.headline} paragraph={props.paragraph} />

      <div
        css={css`
          margin-bottom: 14px;
          display: flex;
          justify-content: center;
        `}
      >
        <SwarovskiButton variant={"green"} as={"button"} onClick={props.buttonAction}>
          <T>{props.buttonLabel}</T>
        </SwarovskiButton>
      </div>
    </>
  );
};
